var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71 9.88125L2.83 6.00125L6.71 2.12125C7.1 1.73125 7.1 1.10125 6.71 0.711249C6.32 0.321249 5.69 0.321249 5.3 0.711249L0.710003 5.30125C0.320003 5.69125 0.320003 6.32125 0.710003 6.71125L5.3 11.3012C5.69 11.6912 6.32 11.6912 6.71 11.3012C7.09 10.9112 7.1 10.2712 6.71 9.88125Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeftArrow);
export default __webpack_public_path__ + "static/media/paginationLeftArrow.b7e2a2c9483b65ea06120b93452b2633.svg";
export { ForwardRef as ReactComponent };